<!-- =========================================================================================
    File Name: ChatNavbar.vue
    Description: Chat Application - Chat navbar
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div v-if="userId != null" class="chat__header">
        <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
            <div class="relative flex mr-4">
                <feather-icon icon="MenuIcon" class="mr-4 cursor-pointer" v-if="isSidebarCollapsed" @click.stop="$emit('openContactsSidebar')" />
                <vs-avatar v-if="userDetails.organizationData.logo" class="m-0 border-2 border-solid border-white" size="40px" :src="organizationLogo(userDetails.organizationData.logo)" @click.stop="$emit('showProfileSidebar', userId)" />
                <vs-avatar
                  v-else
                  class="m-0 border-2 border-solid border-white"
                  size="40px"
                  :src="
                    require('@/assets/images/icons/organization/business_black_36dp.svg')
                  "
                />
                <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(false)"></div>
            </div>
            <div>
              <h6>{{ userDetails.organizationData.name }}</h6>
              <transition name="fade-top-2x"><small v-if="isOrganizationTyping">Typing...</small></transition>
            </div>
            <vs-spacer></vs-spacer>
            <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning stroke-current': isPinnedLocal}, 'w-6', 'h-6']" @click.stop="isPinnedLocal = !isPinnedLocal"></feather-icon>
        </vs-navbar>
    </div>
</template>

<script>
import constants from '@/constants.js';
export default {
  props: {
    userId: {
      type: String,
      required: true
    },
    isPinnedProp: {
      type: Boolean,
      required: true
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      constants,
      isOrganizationTyping: false,
      isOrganizationOnline: false
    }
  },
  computed: {
    organizationLogo () {
      return (logo) => { return this.constants.s3Bucket + '/organization/logo/' + logo };
    },
    isPinnedLocal: {
      get () {
        return this.isPinnedProp
      },
      set (val) {
        const chatData = this.$store.getters['userChat/chatDataOfUser'](this.userId)
        if (chatData) {
          const payload = { id: this.userId, value: val }
          this.$store.dispatch('userChat/toggleIsPinned', payload)
            .then(() => { this.$emit('toggleIsChatPinned', val) })
            .catch((err) => { console.error(err) })
        } else {
          this.$emit('toggleIsChatPinned', val)
        }
      }
    },
    userDetails () {
      // // console.log(this.userId);
      return this.$store.getters['userChat/contact'](this.userId)
    },
    getStatusColor () {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser)

        /*if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }*/

        if (userStatus === true) {
          return 'success';
        } else {
          return 'grey';
        }
      }
    }
  },
  methods: {
    getUserStatus (isActiveUser) {
      //return isActiveUser ? this.$store.state.AppActiveUser.status : this.userDetails.status
      return this.isOrganizationOnline;
    }
  },
  mounted () {
    // listen to organization typing
    this.sockets.subscribe('receiveTyping', data => {
        // // console.log('receiveTyping', data);
        this.isOrganizationTyping = true;
    });

    this.sockets.subscribe('receiveStopTyping', data => {
        // // console.log('organizationStopTyping', data);
        this.isOrganizationTyping = false;
    });

    // organization online status handler
    this.organizationOnlineStatusHandler = setInterval(() => {
      this.$socket.emit('checkOrganizationOnlineStatus', { organizationId: this.userDetails.organizationData._id });
    }, 5000);
    this.sockets.subscribe('receiveStatusOrganizationOnline', data => {
      // // console.log('organization online status', data);
      if(data.status === true) {
        this.isOrganizationOnline = true;
      } else {
        this.isOrganizationOnline = false;
      }
    });
  },
  created () {},
  beforeDestroy() {
    clearInterval(this.organizationOnlineStatusHandler);
  }
}

</script>

<style scoped>
.vs-navbar {
  background-color: white !important;;
}
</style>